import { useState } from "react";
import { useAuth0 } from "@auth0/auth0-react";
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { FiSearch } from "react-icons/fi";

import LoginButton from "./miscComponents/LoginButton";
import ThemeToggle from "./miscComponents/ThemeToggle";

import envolvlyLogo from "./assets/webp/navbarLogo.webp";

// const navigation = [
//   { name: "Demo", href: "demo", scroll: "1450" },
//   { name: "Blog", href: "blog", scroll: "2400" },
//   { name: "Apply", href: "apply", scroll: "3300" },
// ];

function Navbar() {
  const { loginWithRedirect, isAuthenticated, user, isLoading } = useAuth0();
  const [searchTerm, setSearchTerm] = useState("");
  const navigate = useNavigate();

  const handleSearchSubmit = (e) => {
    e.preventDefault();
    if (searchTerm.trim()) {
      navigate(`/explore?q=${searchTerm.trim()}`);
    }
  };

  const truncateUsername = (name) => {
    return name?.length > 12 ? name.substring(0, 12) + "..." : name;
  };

  return (
    <div className="text-white p-2 backdrop-blur-md shadow-md sticky top-0 left-0 right-0 z-10 w-full isolate bg-envolvlyGray">
      <div className="px-4 pt-4 lg:px-8">
        <div>
          <nav
            className="flex h-9 items-center justify-between"
            aria-label="Global"
          >
            <div className="flex lg:min-w-0 lg:flex-1" aria-label="Global">
              <Link to="/">
                <span className="-m-1.5 p-1.5">
                  <span className="sr-only">Envolvly</span>
                  {/* Desktop Logo */}
                  <img
                    src={envolvlyLogo}
                    className="hidden h-8 -ml-3 lg:block"
                    alt="Envolvly"
                  />
                  {/* Mobile Logo */}
                  <img
                    src={"/favicon.ico"}
                    className="block h-10 lg:hidden"
                    alt="Envolvly"
                  />
                </span>
              </Link>
            </div>
            <div className="hidden lg:flex lg:min-w-0 lg:flex-1 lg:justify-center lg:gap-x-12">
              <form
                onSubmit={handleSearchSubmit}
                className="relative w-full max-w-md"
              >
                <input
                  type="text"
                  placeholder="Search..."
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                  className="w-full px-4 py-2 rounded-full bg-gray-700 text-white placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-primary-500"
                />
                <button
                  type="submit"
                  className="absolute top-1/2 right-3 -translate-y-1/2"
                >
                  <FiSearch className="w-5 h-5 text-gray-400" />
                </button>
              </form>
            </div>
            <div className="hidden lg:flex lg:min-w-0 lg:flex-1 lg:justify-end items-center gap-4">
              {isLoading ? (
                <div className="flex items-center gap-3">
                  <div className="w-8 h-8 rounded-full bg-gray-700 animate-pulse"></div>
                  <div className="h-4 w-24 bg-gray-700 rounded animate-pulse"></div>
                </div>
              ) : isAuthenticated ? (
                <>
                  <Link to="/profile" className="flex items-center gap-3 group">
                    <div className="relative">
                      <img
                        src={user?.picture}
                        alt={user?.name}
                        className="w-8 h-8 rounded-full object-cover ring-2 ring-[#6CF9A9] ring-offset-2 ring-offset-envolvlyGray"
                      />
                      <div className="absolute -bottom-1 -right-1 w-3 h-3 bg-[#6CF9A9] rounded-full border-2 border-envolvlyGray"></div>
                    </div>
                    <span className="text-sm font-medium group-hover:text-[#6CF9A9] transition-colors">
                      {truncateUsername(user?.name)}
                    </span>
                  </Link>
                  <Link
                    to="/create"
                    className="inline-flex items-center px-3 py-1.5 text-sm font-medium rounded-lg text-white bg-[#6CF9A9] hover:bg-[#5CE99A] transition-colors"
                  >
                    +
                  </Link>
                </>
              ) : (
                <div className="inline-block rounded-lg px-3 py-1.5 text-sm font-semibold leading-6 shadow-sm ring-1 ring-gray-900/10 hover:ring-gray-900/20">
                  <LoginButton />
                </div>
              )}
            </div>
            {/* Mobile Profile Avatar */}
            <div className="flex lg:hidden justify-end items-center gap-2">
              {isLoading ? (
                <div className="w-8 h-8 rounded-full bg-gray-700 animate-pulse"></div>
              ) : isAuthenticated ? (
                <>
                  <Link
                    to="/create"
                    className="inline-flex items-center px-2 py-1 text-sm font-medium rounded-md text-white bg-[#6CF9A9] hover:bg-[#5CE99A] transition-colors"
                  >
                    +
                  </Link>
                  <Link to="/profile">
                    <img
                      src={user?.picture}
                      alt={user?.name}
                      className="w-8 h-8 rounded-full object-cover ring-2 ring-[#6CF9A9] ring-offset-2 ring-offset-envolvlyGray"
                    />
                  </Link>
                </>
              ) : (
                <div className="inline-block rounded-lg px-3 py-1.5 text-sm font-semibold leading-6 shadow-sm ring-1 ring-gray-900/10 hover:ring-gray-900/20">
                  <LoginButton />
                </div>
              )}
            </div>
          </nav>
        </div>
      </div>
    </div>
  );
}

export default Navbar;
